export const RestrictedSvg = function RestrictedSvg() {
    return (
        <svg
            width="100%"
            height="343px"
            viewBox="0 0 660 343"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>locked door</title>
            <defs>
                <rect id="path-1" x="264" y="55" width="123" height="259" />
                <filter
                    x="-2.4%"
                    y="-1.2%"
                    width="104.9%"
                    height="102.3%"
                    filterUnits="objectBoundingBox"
                    id="filter-2"
                >
                    <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur
                        stdDeviation="1"
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.149448208 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <path
                    d="M325.031371,141.324747 L325.031371,142.624693 C325.031371,143.230847 325.521406,143.720152 326.12683,143.720152 C326.731524,143.720152 327.22229,143.230847 327.22229,142.624693 L327.22229,141.317444 C327.893442,140.930382 328.352074,140.214682 328.352074,139.389435 C328.352074,138.162521 327.353745,137.162001 326.12683,137.162001 C324.899185,137.162001 323.900856,138.162521 323.900856,139.389435 C323.900856,140.200075 324.33904,140.930382 325.031371,141.324747 M336.305841,146.079042 C336.305841,146.341952 336.244496,148.686236 334.116383,148.773873 C330.94028,148.898025 318.314012,148.788479 318.156996,148.781176 C317.962005,148.781176 316.251627,148.686236 315.92518,145.626252 L315.92518,132.933527 L336.305841,132.933527 L336.305841,146.079042 Z M326.083012,119.649253 C332.235844,119.649253 332.588582,124.754095 332.6083,125.301824 L332.6083,130.742607 L319.558454,130.742607 L319.557724,125.60125 C319.564297,125.352946 319.776086,119.649253 326.083012,119.649253 Z M337.401301,130.742607 L334.799219,130.742607 L334.798489,125.272612 C334.72984,122.570478 332.819358,117.458333 326.083012,117.458333 C319.345935,117.458333 317.436184,122.745752 317.367535,125.572038 L317.367535,130.742607 L314.82972,130.742607 C314.225027,130.742607 313.734261,131.231913 313.734261,131.838067 L313.734261,145.684677 C313.734261,145.721192 313.736452,145.757707 313.740103,145.794223 C314.16295,150.008091 316.861433,151.052429 318.16576,150.972095 C318.498049,150.979398 323.591206,151.023217 328.085512,151.023217 C330.655461,151.023217 333.030417,151.008611 334.20548,150.964792 C337.599214,150.826034 338.496761,147.707626 338.496761,146.079042 L338.496761,131.838067 C338.496761,131.231913 338.005995,130.742607 337.401301,130.742607 L337.401301,130.742607 Z"
                    id="path-3"
                />
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Light---Block-Model-Dashboard---Restricted-Access"
                    transform="translate(-522.000000, -247.000000)"
                >
                    <g id="locked-door" transform="translate(522.000000, 247.000000)">
                        <polygon
                            id="Rectangle"
                            fill="#FAFAFA"
                            fillRule="nonzero"
                            points="26 46 106 10 227 18 271 0 355 10 483 10 642 46 637 170 659.47949 240.435735 654 313 12 313.5 0 232 41 135"
                        />
                        <rect
                            id="Rectangle"
                            fillOpacity="0.480207"
                            fill="#E7E7E7"
                            fillRule="nonzero"
                            x="253"
                            y="44"
                            width="144"
                            height="272"
                        />
                        <g id="Rectangle" fillRule="nonzero">
                            <use
                                fill="black"
                                fillOpacity="1"
                                filter="url(#filter-2)"
                                href="#path-1"
                            />
                            <use fill="#FFFFFF" href="#path-1" />
                        </g>
                        <polygon
                            id="Path-27"
                            fill="#F2F2F2"
                            fillRule="nonzero"
                            opacity="0.486351376"
                            points="264.536055 321.356375 385 321.356375 396.519031 342.236201 253 342.236201"
                        />
                        <rect
                            id="Rectangle"
                            stroke="#D8D8D8"
                            strokeWidth="2"
                            fill="#F2F2F2"
                            fillRule="nonzero"
                            x="279.5"
                            y="76"
                            width="92"
                            height="114"
                        />
                        <rect
                            id="Rectangle"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            fillRule="nonzero"
                            x="281"
                            y="78"
                            width="92"
                            height="114"
                        />
                        <rect
                            id="Rectangle"
                            stroke="#D8D8D8"
                            strokeWidth="2"
                            fill="#F2F2F2"
                            fillRule="nonzero"
                            x="279.5"
                            y="221"
                            width="92"
                            height="76"
                        />
                        <rect
                            id="Rectangle"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            fillRule="nonzero"
                            x="281"
                            y="223"
                            width="92"
                            height="76"
                        />
                        <path
                            d="M372.5,197.5 C376.365993,197.5 379.5,200.634007 379.5,204.5 C379.5,208.365993 376.365993,211.5 372.5,211.5 C369.329361,211.5 366.651072,209.391996 365.790189,206.501043 L356,206.5 C354.895431,206.5 354,205.604569 354,204.5 C354,203.395431 354.895431,202.5 356,202.5 L365.789892,202.499954 C366.650456,199.608489 369.328996,197.5 372.5,197.5 Z"
                            id="Combined-Shape"
                            fill="#D8D8D8"
                            fillRule="nonzero"
                        />
                        <line
                            x1="0.809442695"
                            y1="316.340315"
                            x2="659"
                            y2="314"
                            id="land"
                            stroke="#EBEBEB"
                            strokeWidth="2"
                        />
                        <path
                            d="M338,131.611816 C338,139.870605 338,144.666667 338,146 C338,146 337,147 335,149 L318,149 L315,147 L315,132 L338,131.611816 Z"
                            id="Path-40"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                        />
                        <mask id="mask-4" fill="white">
                            <use href="#path-3" />
                        </mask>
                        <use id="Mask" fill="#265C7F" fillRule="nonzero" href="#path-3" />
                        <path
                            d="M282,78 L282,188 L284,185 C284.666667,151 290,126.666667 300,112 C310,97.3333333 324.333333,86 343,78 L282,78 Z"
                            id="Path-39"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            opacity="0.531226749"
                        />
                        <path
                            d="M282,222.5 L282,294.5 L283.147541,292.536364 C283.530055,270.281818 286.590164,254.354545 292.327869,244.754545 C298.065574,235.154545 306.289617,227.736364 317,222.5 L282,222.5 Z"
                            id="Path-39"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            opacity="0.531226749"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};
